import { createPortal } from "react-dom";
import * as Sentry from "@sentry/react";
import IconButton from "../../../../../design-system/components/IconButton/IconButton.jsx";
import Button from "../../../../../design-system/components/Button/Button.jsx";
import { Variants } from "../../../../../design-system/components/Button/Variants.jsx";
import { MUTATIONS, useMutation } from "../../../../../api";
import type { WorkshopId } from "../../../../../api/workshop";
import styles from "./Overlay.css";
import { useLernreiseCompletionCheck } from "../../hooks/useLernreiseCompletionCheck";

const Overlay = ({
  workshopId,
  workshopSlug,
  onClose,
  onSaveError,
}: {
  workshopId: WorkshopId;
  workshopSlug: string;
  onClose: () => void;
  onSaveError: () => void;
}) => {
  const [doSetLernreiseCompleted, { isLoading }] = useMutation(
    MUTATIONS.setLernreiseCompleted,
  );
  const { markChecked, clearCheck } = useLernreiseCompletionCheck(workshopId);

  async function handleClickCompleted() {
    try {
      await doSetLernreiseCompleted({ workshopId, slug: workshopSlug });
      clearCheck();
    } catch (err) {
      Sentry.captureException(err);
      markChecked();
      onSaveError();
    }
    onClose();
  }

  function handleClickNotCompleted() {
    markChecked();
    onClose();
  }

  return (
    <>
      {createPortal(
        <div className={styles.outerDiv}>
          <div className={styles.innerDiv}>
            <div className={styles.containerCloseButton}>
              <IconButton
                name="xmark"
                size={"24px"}
                onClick={handleClickNotCompleted}
                aria-label="Schließen"
              />
            </div>
            <div className={styles.contentContainer}>
              <h1 className={styles.heading}>
                Kurze Frage:
                <br />
                Macht ihr gerade einen FREI DAY Kick-off in der Schule?
              </h1>
              <div className={styles.containerButton}>
                <Button
                  width={"fit"}
                  onClick={handleClickCompleted}
                  disabled={isLoading}
                >
                  {isLoading ? "Wird gespeichert..." : "Ja, weiter"}
                </Button>
                <Button
                  width={"fit"}
                  onClick={handleClickNotCompleted}
                  variant={Variants.SECONDARY}
                >
                  Nein, Ich schaue nur
                </Button>
              </div>
              <p className={styles.text}>
                *Als kostenfreies Angebot müssen wir verstehen, wie die Sparks
                verwendet werden. <br /> Mit deiner Antwort hilfst du uns
                ungemein.
              </p>
            </div>
          </div>
        </div>,
        document.body,
      )}
    </>
  );
};

export default Overlay;
